import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { FeatureFlagService } from '@next/core-lib/featureflag';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { LicenseRequestModel } from '../models/license.request.model';

@Injectable({
  providedIn: 'root',
})
export class IdentificationService {
  private readonly env = inject<Environment>(EnvironmentInjector);
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/business-partner-v2-service`;
  customer$ = this.store.select(UserSelectors.selectCustomer);
  featureFlags: string[];
  constructor(
    private readonly http: HttpClient,
    private readonly store: Store,
    private readonly featureFlagService: FeatureFlagService,
  ) {
    this.customer$
      .pipe(
        map((selectedCustomer) => selectedCustomer?.shipTos[0]?.salesAreas[0]?.salesOrganization),
        switchMap((salesOrganization) =>
          this.featureFlagService.getFeatureFlagsForSalesArea(salesOrganization),
        ),
        filter((featureFlags) => featureFlags !== undefined && featureFlags.length > 0),
      )
      .subscribe((featureFlags) => {
        this.featureFlags = featureFlags;
      });
  }

  insert(request: LicenseRequestModel): Observable<unknown> {
    return this.http.post(`${this.baseUrl}/licenses`, request);
  }
}
